// src/pages/Login.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Lock, Mail, AlertCircle } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, pass);
      navigate('/admin');
    } catch {
      setError('E-posta veya şifre hatalı.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="text-center mb-10">
          <div className="text-4xl font-bold tracking-[10px] text-white mb-1">AGE</div>
          <div className="text-[10px] tracking-[3px] uppercase text-stone-500">
            İzolasyon ve Çatı Sistemleri
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs text-stone-500 tracking-widest uppercase mb-2">
              E-posta
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-600" size={16} />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="w-full bg-stone-900 border border-stone-800 text-white pl-10 pr-4 py-3 rounded-lg text-sm focus:outline-none focus:border-stone-500 transition-colors"
                placeholder="E Mail"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs text-stone-500 tracking-widest uppercase mb-2">
              Şifre
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-600" size={16} />
              <input
                type="password"
                value={pass}
                onChange={e => setPass(e.target.value)}
                required
                className="w-full bg-stone-900 border border-stone-800 text-white pl-10 pr-4 py-3 rounded-lg text-sm focus:outline-none focus:border-stone-500 transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <div className="flex items-center gap-2 text-red-400 text-sm bg-red-400/10 border border-red-400/20 rounded-lg px-3 py-2">
              <AlertCircle size={15} />
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-white text-stone-900 font-semibold py-3 rounded-lg text-sm tracking-wide hover:bg-stone-200 transition-colors disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
          <a
            href="https://panel.ageizolasyon.com/usta/giris"
            className="block w-full text-center bg-stone-200 hover:bg-white text-white font-semibold py-3 rounded-lg text-sm tracking-wide transition-colors"
          >
            Usta Giriş
          </a>
        </form>
      </div>
    </div>
  );
}
